<template>
  <div class="t-faq">
    <div class="t-lk-container">
      <link-back-cmp :btn="$root.staticText.lk.faqAll" link-name="lk-faq" class="t-lk-container-mobile"> </link-back-cmp>

      <div class="t-faq__container">
        <div v-if="category" class="t-faq__left">
          <div v-animation:bottom.delay class="t-faq__item _bottom">
            <h1 class="t-lk-title t-faq-category">{{ category.title }}</h1>
            <div class="t-faq__desc">{{ category.description }}</div>
            <div class="t-faq-block">
              <router-link :to="item.link" class="t-faq-block__item t-faq__question" v-for="item in category.questions" :key="item.id">
                {{ item.name }}
              </router-link>
            </div>
          </div>

          <banner-native-cmp v-if="isMobile && banner" v-animation:bottom.delay :banner="banner" class="t-faq__banner">
          </banner-native-cmp>

          <div v-if="category.subcategories.length > 0" v-animation:bottom.delay class="t-faq__item _sub">
            <div class="t-faq-subcategory" v-for="item in category.subcategories">
              <h2 class="t-faq__title">{{ item.title }}</h2>
              <div class="t-faq-subcategory__questions">
                <router-link :to="question.link" class="t-faq__question" v-for="question in item.questions" :key="question.id">
                  {{ question.name }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isMobile" v-animation:bottom.delay class="t-faq__right">
          <banner-native-cmp v-if="banner" :banner="banner" :is-vertical="true"></banner-native-cmp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import linkBack from '@components/lk/link-back/link-back.vue'
import bannerNative from '@components/lk/banner-native/banner-native.vue'
import { mapState } from 'vuex'
import { router } from '@src/routes'

export default {
  name: 'lk-faq-category',
  data() {
    return {
      category: null,
      banner: null,
    }
  },
  components: {
    'link-back-cmp': linkBack,
    'banner-native-cmp': bannerNative,
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  methods: {
    setData(data) {
      this.category = data.category
      this.banner = data.banner
    },
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/faqCategory.json' : to.path.substring(1).replace(router.history.base, '')

    Vue.http.get(url).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/faq/category/index.vue